import { render, staticRenderFns } from "./UserTitleList.vue?vue&type=template&id=72f12e4c&scoped=true"
import script from "./UserTitleList.vue?vue&type=script&lang=ts"
export * from "./UserTitleList.vue?vue&type=script&lang=ts"
import style0 from "./UserTitleList.vue?vue&type=style&index=0&id=72f12e4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f12e4c",
  null
  
)

export default component.exports